module.exports = __webpack_public_path__ + "public/files/img/banner.49278224.webp";